import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Globe } from 'lucide-react';


export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    { path: '/hire-pdmlink-customization-expert', label: 'Windchill PDMLink' },
    { path: '/hire-projectlink-customization-expert', label: 'Windchill ProjectLink' },
    { path: '/hire-supplier-management-expert', label: 'Supplier Management' },
    { path: '/hire-creo-view-visualization-expert', label: 'Creo View' },
  ];

  const solutions = [
    { path: '/hire-infrastructure-customization-expert', label: 'Infrastructure' },
    { path: '/hire-windchill-customization-expert', label: 'Customization' },
    { path: '/hire-windchill-upgrade-expert', label: 'Upgrades' },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            {/* <h3 className="text-xl font-bold text-[#00890b] mb-4">
              Windchill Customization
            </h3> */}
            <img src="/logo.png" alt="Logo" style={{ height: '90px' }} />
            <p className="text-gray-400 mb-4">
              15+ Years of Windchill Expertise
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-gray-400">
                <Mail size={18} />
                <a
                  href="mailto:jay@windchillcustomization.com"
                  className="hover:text-[#00890b]"
                >
                  jay@windchillcustomization.com
                </a>
              </div>
              <div className="flex items-center space-x-2 text-gray-400">
                <Globe size={18} />
                <span>windchillcustomization.com</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              {services.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-gray-400 hover:text-[#00890b] transition-colors block"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Solutions</h4>
            <ul className="space-y-2">
              {solutions.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-gray-400 hover:text-[#00890b] transition-colors block"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-[#00890b] transition-colors block"
                >
                  Home
                </Link>
              </li>
              <li>
                <button
                  onClick={() => {
                    const contactForm = document.getElementById('contact-form');
                    if (contactForm) {
                      contactForm.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="text-gray-400 hover:text-[#00890b] transition-colors text-left"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>
            &copy; {currentYear} Windchill Customization. All rights reserved.
            <span className="hidden md:inline mx-2">|</span>
            <span className="block md:inline mt-2 md:mt-0">
              Powered by{' '}
              <a
                href="https://www.prosperasoft.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00890b] transition-colors hover:underline"
              >
                Prosperasoft
              </a>
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};